import COLOR_THEMES from "@/global-config";
import {SendAlert} from "@/functions/Alert";

export function GenericError(){
    if (document.getElementById('isRestarting')?.getAttribute("data-value") !== 'true' ){
        SendAlert('Oops... Algo deu errado.',COLOR_THEMES.colors.danger);
        return true;
    }
    return false;
}